import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchProgramsQueryVariables = SchemaTypes.Exact<{
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
  filter?: SchemaTypes.InputMaybe<SchemaTypes.ProgramFilteringRule>;
  pagination?: SchemaTypes.InputMaybe<SchemaTypes.Pagination>;
  sort?: SchemaTypes.InputMaybe<SchemaTypes.ProgramSortingRule>;
}>;


export type FetchProgramsQuery = (
  { __typename: 'Query' }
  & { programs: (
    { __typename: 'PaginatedProgram' }
    & Pick<SchemaTypes.PaginatedProgram, 'count'>
    & { items: Array<(
      { __typename: 'Program' }
      & ProgramListItemDataFragment
    )> }
  ) }
);

export type DeleteProgramMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type DeleteProgramMutation = (
  { __typename: 'Mutation' }
  & { deleteProgram: (
    { __typename: 'DeleteProgramSuccessfulResponse' }
    & Pick<SchemaTypes.DeleteProgramSuccessfulResponse, 'success' | 'deletedId'>
  ) | (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) }
);

export type DeleteAssessmentRunsMutationVariables = SchemaTypes.Exact<{
  programId: SchemaTypes.Scalars['ObjectID']['input'];
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
  groupId: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type DeleteAssessmentRunsMutation = (
  { __typename: 'Mutation' }
  & { deleteAssessmentRuns: (
    { __typename: 'DeleteAssessmentRunsSuccessfulResponse' }
    & Pick<SchemaTypes.DeleteAssessmentRunsSuccessfulResponse, 'success'>
  ) | (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) }
);

export type ProgramListItemDataFragment = (
  { __typename: 'Program' }
  & Pick<SchemaTypes.Program, 'id' | 'name' | 'description' | 'companyId' | 'createdAt' | 'updatedAt' | 'courseInstanceId' | 'occurrence' | 'assessmentRunIds'>
  & { courseInstance: (
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'id' | 'name' | 'description'>
    & { duration: (
      { __typename: 'Duration' }
      & Pick<SchemaTypes.Duration, 'value' | 'unit'>
    ) }
  ), assessmentRuns: Array<(
    { __typename: 'AssessmentRun' }
    & AssessmentRunDataFragment
  )> }
);

export type AssessmentRunDataFragment = (
  { __typename: 'AssessmentRun' }
  & Pick<SchemaTypes.AssessmentRun, 'id' | 'name' | 'groupId' | 'status' | 'startDate' | 'endDate' | 'createdAt' | 'updatedAt'>
  & { group: (
    { __typename: 'Group' }
    & Pick<SchemaTypes.Group, 'id' | 'name'>
  ) }
);

export const AssessmentRunDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AssessmentRunData on AssessmentRun {
  id
  name
  groupId
  group {
    id
    name
  }
  status
  startDate
  endDate
  createdAt
  updatedAt
}
    `;
export const ProgramListItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ProgramListItemData on Program {
  id
  name
  description
  companyId
  createdAt
  updatedAt
  courseInstanceId
  courseInstance {
    id
    name
    description
    duration {
      value
      unit
    }
  }
  occurrence
  assessmentRunIds
  assessmentRuns {
    ...AssessmentRunData
  }
}
    `;
export const FetchProgramsDocument = /*#__PURE__*/ gql`
    query FetchPrograms($companyId: ObjectID!, $filter: ProgramFilteringRule, $pagination: Pagination, $sort: ProgramSortingRule) {
  programs(
    companyId: $companyId
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    count
    items {
      ...ProgramListItemData
    }
  }
}
    ${ProgramListItemDataFragmentDoc}
${AssessmentRunDataFragmentDoc}`;

/**
 * __useFetchProgramsQuery__
 *
 * To run a query within a React component, call `useFetchProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProgramsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFetchProgramsQuery(baseOptions: Apollo.QueryHookOptions<FetchProgramsQuery, FetchProgramsQueryVariables> & ({ variables: FetchProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProgramsQuery, FetchProgramsQueryVariables>(FetchProgramsDocument, options);
      }
export function useFetchProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProgramsQuery, FetchProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProgramsQuery, FetchProgramsQueryVariables>(FetchProgramsDocument, options);
        }
export function useFetchProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchProgramsQuery, FetchProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchProgramsQuery, FetchProgramsQueryVariables>(FetchProgramsDocument, options);
        }
export type FetchProgramsQueryHookResult = ReturnType<typeof useFetchProgramsQuery>;
export type FetchProgramsLazyQueryHookResult = ReturnType<typeof useFetchProgramsLazyQuery>;
export type FetchProgramsSuspenseQueryHookResult = ReturnType<typeof useFetchProgramsSuspenseQuery>;
export type FetchProgramsQueryResult = Apollo.QueryResult<FetchProgramsQuery, FetchProgramsQueryVariables>;
export const DeleteProgramDocument = /*#__PURE__*/ gql`
    mutation DeleteProgram($id: ObjectID!, $companyId: ObjectID!) {
  deleteProgram(id: $id, companyId: $companyId) {
    __typename
    ... on DeleteProgramSuccessfulResponse {
      success
      deletedId
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    `;
export type DeleteProgramMutationFn = Apollo.MutationFunction<DeleteProgramMutation, DeleteProgramMutationVariables>;

/**
 * __useDeleteProgramMutation__
 *
 * To run a mutation, you first call `useDeleteProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProgramMutation, { data, loading, error }] = useDeleteProgramMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeleteProgramMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProgramMutation, DeleteProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProgramMutation, DeleteProgramMutationVariables>(DeleteProgramDocument, options);
      }
export type DeleteProgramMutationHookResult = ReturnType<typeof useDeleteProgramMutation>;
export type DeleteProgramMutationResult = Apollo.MutationResult<DeleteProgramMutation>;
export type DeleteProgramMutationOptions = Apollo.BaseMutationOptions<DeleteProgramMutation, DeleteProgramMutationVariables>;
export const DeleteAssessmentRunsDocument = /*#__PURE__*/ gql`
    mutation DeleteAssessmentRuns($programId: ObjectID!, $companyId: ObjectID!, $groupId: ObjectID!) {
  deleteAssessmentRuns(
    programId: $programId
    companyId: $companyId
    groupId: $groupId
  ) {
    __typename
    ... on DeleteAssessmentRunsSuccessfulResponse {
      success
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    `;
export type DeleteAssessmentRunsMutationFn = Apollo.MutationFunction<DeleteAssessmentRunsMutation, DeleteAssessmentRunsMutationVariables>;

/**
 * __useDeleteAssessmentRunsMutation__
 *
 * To run a mutation, you first call `useDeleteAssessmentRunsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssessmentRunsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssessmentRunsMutation, { data, loading, error }] = useDeleteAssessmentRunsMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      companyId: // value for 'companyId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteAssessmentRunsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssessmentRunsMutation, DeleteAssessmentRunsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssessmentRunsMutation, DeleteAssessmentRunsMutationVariables>(DeleteAssessmentRunsDocument, options);
      }
export type DeleteAssessmentRunsMutationHookResult = ReturnType<typeof useDeleteAssessmentRunsMutation>;
export type DeleteAssessmentRunsMutationResult = Apollo.MutationResult<DeleteAssessmentRunsMutation>;
export type DeleteAssessmentRunsMutationOptions = Apollo.BaseMutationOptions<DeleteAssessmentRunsMutation, DeleteAssessmentRunsMutationVariables>;